/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  return async function onSubmit({ value }) {
    return props.onSubmit && props.onSubmit(value.selected)
  }
}
